import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { UserBet } from '../../models/UserBet';
import { RootState } from '../../models/RootState';
import './ExchOpenBets.scss';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { getCurrencyTypeFromToken } from '../../store';
import { MarketTypeMap } from '../../util/stringUtil';

type StoreProps = {
  openBets: UserBet[];
};

const getDisplayName = (runnerName: string) => {
  let name =
    runnerName.split(':').length > 1
      ? runnerName.split(':')[1]
      : runnerName.split(':')[0];
  if (name.toLowerCase().includes('crudeoil')) return 'CRUDE OIL';
  else if (name.toLowerCase().includes('gold')) return 'GOLD';
  else if (name.toLowerCase().includes('silver')) return 'SILVER';
  else if (name.toLowerCase().includes('banknifty')) return 'BANK NIFTY';
  return name;
};

const ExchOpenBets: React.FC<StoreProps> = (props) => {
  const { openBets } = props;
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const getBetDisplayName = (bet: UserBet) => {
    switch (bet.marketType) {
      // TODO: remove binary
      case 'FANCY':
      case 'BINARY':
        return (
          (bet.marketType === 'BINARY'
            ? getDisplayName(bet.outcomeDesc)
            : bet.marketName) +
          ' @ ' +
          Number(bet.oddValue * 100 - 100).toFixed(0)
        );
      case 'BOOKMAKER':
        return `${
          bet.marketName.toLowerCase().includes('toss') ? 'Toss' : 'BM'
        } - ${bet.outcomeDesc}`;
      case 'MATCH_ODDS':
        if (bet.marketName === 'Completed Match') {
          return 'Completed Match - ' + bet.outcomeDesc;
        } else if (bet.marketName === 'Tied Match') {
          return 'Tied Match - ' + bet.outcomeDesc;
        } else {
          return 'MO - ' + bet.outcomeDesc;
        }
      default:
        return bet.marketName + ' - ' + bet.outcomeDesc;
    }
  };

  const getBetOddValue = (bet: UserBet) => {
    return bet.marketType === 'FANCY' || bet.marketType === 'BINARY'
      ? Number(bet.sessionRuns).toFixed(0)
      : bet.marketType === 'BOOKMAKER'
      ? Number(bet.oddValue * 100 - 100).toFixed(2)
      : Number(bet.oddValue);
  };

  const getBetStakeAmount = (bet: UserBet) =>
    Number(bet.stakeAmount / cFactor).toFixed(2);

  return (
    <div className="open-bets-ctn">
      <Table className="exch-open-bets-table">
        <TableHead className="open-bets-table-head">
          <TableRow className="open-bets-table-row">
            <TableCell className="market-cell">Market</TableCell>
            <TableCell className="odds-cell" align="right">
              Odds
            </TableCell>
            <TableCell className="stake-cell" align="right">
              Stake
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className="open-bets-table-body">
          {openBets.map((bet, idx) => (
            <TableRow
              key={'row' + idx}
              className={
                bet.betType === 'BACK'
                  ? 'back-bet open-bets-table-row'
                  : 'lay-bet open-bets-table-row'
              }
            >
              <TableCell key={'market-cell-row' + idx}>
                {getBetDisplayName(bet)}
              </TableCell>
              <TableCell key={'odds-cell-row' + idx} align="right">
                {getBetOddValue(bet)}
              </TableCell>
              <TableCell key={'stake-cell-row' + idx} align="right">
                {getBetStakeAmount(bet)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    openBets: state.exchBetslip.openBets,
  };
};

export default connect(mapStateToProps)(ExchOpenBets);
